<template>
  <div class="navbarsidebar_background">
    <div class="navbarsidebar_content">
      <div class="buttons-block nav_avatar" v-if="isAuth">
        <div class="info" @click="$emit('openAccount')">
          <div class="avatar"></div>
          <div class="text">
            <p class="nickname">{{ currentUser.name }} {{ currentUser.surname }}</p>
            <span class="role">{{ rolename }}</span>
          </div>
        </div>
        <button class="logout" @click="logout"><i class="mdi mdi-logout"></i></button>
      </div>
      <button v-else class="sidebar_signin" @click="$emit('open-modal')">
        Авторизоваться <i class="icon-button-arrow"></i>
      </button>

      <CoursesList v-if="isAuth && userRole != 'user'" :categories-list="CategoriesList" />

      <UserCoursesList v-if="userRole === 'user'" :courses-list="RightCoursesList" />

      <!-- <ul class="page-map">
            <li class="list_item">О нас</li>
            <li class="list_item">Карьера</li>
            <li class="list_item">Поддержка</li>
            <li class="list_item">Партнёр</li>
            <li class="list_item">Карта сайта</li>
            <li class="list_item">Контакты</li>
         </ul> -->
    </div>
    <i class="icon-close" @click="$emit('close-sidebar')"></i>
  </div>
</template>

<script>
import CoursesList from '@/components/right_block/CoursesList'
import UserCoursesList from '@/components/right_block/UserCoursesList'

export default {
  components: {
    CoursesList,
    UserCoursesList
  },
  computed: {
    RightCoursesList() {
      return this.$store.state.courses.userRightCoursesList.courses
    },
    rolename() {
      return this.$store.state.auth.rolename
    },
    userRole() {
      return this.$store.state.auth.role[0]
    },
    currentUser() {
      return this.$store.state.auth.currentUser
    },
    isAuth() {
      return this.$store.state.auth.auth
    },
    CategoriesList() {
      return this.$store.state.categories.categoriesList
    }
  },
  methods: {
    back() {
      this.$router.push('/')
    },
    logout() {
      localStorage.removeItem('user-token')
      delete this.$axios.defaults.headers.common['Authorization']
      delete this.$axios2.defaults.headers.common['Authorization']
      this.$store.commit('AUTH_LOGOUT')
      this.back()
      this.$emit('close-sidebar')
    }
  }
}
</script>
